<div>
  <div class="flex items-center gap-2.5">
    @if (url()) {
      <button type="button" (click)="abrirAmpliada()" class="shrink-0" [attr.aria-label]="'Ver foto en grande — ' + etiqueta">
        <img [src]="url()" [alt]="etiqueta" class="w-11 h-11 rounded-lg object-cover border border-[var(--border)]" />
      </button>
    } @else {
      <button type="button" (click)="mostrarCamara.set(true)" class="shrink-0" [attr.aria-label]="'Tomar foto ' + etiqueta">
        <span class="w-11 h-11 rounded-lg border border-dashed border-[var(--faint)] text-[16px] flex items-center justify-center">
          📷
        </span>
      </button>
    }
    <span [class]="foto ? 'flex-1 text-[13px] font-semibold' : 'flex-1 text-[13px] font-semibold text-[var(--faint)]'">{{ etiqueta }}</span>
    @if (foto) {
      <button type="button" (click)="mostrarCamara.set(true)" class="shrink-0 text-[11.5px] font-semibold text-[var(--blue-ink)] px-2 py-1">
        Repetir
      </button>
      <button type="button" (click)="eliminar.emit(foto.id)" [attr.aria-label]="'Eliminar foto ' + etiqueta"
              class="shrink-0 text-[12px] font-bold text-[var(--coral-ink)] px-2 py-1">
        ✕
      </button>
    }
  </div>
  @if (mostrarCamara()) {
    <div class="mt-2">
      <app-camara-captura [etiqueta]="etiqueta" (foto)="alCapturar($event)" />
    </div>
  }
  @if (verAmpliada()) {
    <app-visor-imagen [url]="url()!" [titulo]="etiqueta" (cerrar)="cerrarAmpliada()" />
  }
</div>
